import "@shared/dom-polyfills/classList";
import "@shared/dom-polyfills/dataset";
import Cookie from "js-cookie";
import { getProductQRCodeUrl } from "../helpers";

(function() {
  const container = document.getElementById("xcxh");
  if (!container) return;
  const dontRemindButton = document.getElementById("J-xcxh-dont-remind");
  const goonButton = document.getElementById("J-xcxh-goon");
  const imgQrcode = document.getElementById("J-xcxh-qrcode-img");

  goonButton.addEventListener("click", function() {
    closeXcxh();
  });
  dontRemindButton.addEventListener("click", function() {
    Cookie.set("never-show-xcxh", "1", { expires: 365 });
    closeXcxh();
  });

  if (imgQrcode) {
    imgQrcode.src = getProductQRCodeUrl({
      productId: imgQrcode.dataset.productId,
      utmParam: "utm_source=www&utm_campaign=xcxh&utm_content=qrcode",
    });
    imgQrcode.style.visibility = "visible";
  }

  function closeXcxh() {
    document.querySelector(".product-detail-page").classList.add("xcxh-container-hidden");
  }
})();

require("./xiaochengxuhua.less");